import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import { handleError } from "../../utils/handleError";

const initialState = {
	isLoading: true,
	error: null,
	folders:null,
	message: null,
	files: null,
	selectedFile: null,
	pagination: null,
};

const filesSlice = createSlice({
	name: 'files',
	initialState,
	reducers: {
		clearError: (state) => {
			state.error = null;
		},
		clearMessage: (state) => {
			state.message = null;
		},
		clearSelectedFile: (state) => {
			state.selectedFile = null;
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchAllFilesByQuery.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(fetchFileById.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(fetchFileById.fulfilled, (state, action) => {
				state.isLoading = false;
				state.selectedFile = action.payload?.file || null;
				state.message = action.payload?.message || null;
			})
			.addCase(fetchFileById.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload?.message || "Unable to fetch file.";
			})
			.addCase(fetchAllFilesByQuery.fulfilled, (state, action) => {
				state.isLoading = false;
				state.files = action.payload?.files || [];
				state.pagination = action.payload?.pagination || null;
				state.message = action.payload?.message || null;
			})
			.addCase(fetchAllFilesByQuery.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload?.message || "Unable to fetch files.";
			})

			.addCase(deleteFile.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(deleteFile.fulfilled, (state, action) => {
				state.isLoading = false;
				state.message = action.payload?.message || "File deleted successfully.";
			})
			.addCase(deleteFile.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload?.message || "Unable to delete file.";
			})
			.addCase(fetchAllFoldersByQuery.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(fetchAllFoldersByQuery.fulfilled, (state, action) => {
				state.isLoading = false;
				state.folders = action.payload?.folders || [];
				state.pagination = action.payload?.pagination || null;
				state.message = action.payload?.message || null;
			})
			.addCase(fetchAllFoldersByQuery.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload?.message || "Unable to fetch folders.";
			})
	},
});


export const fetchAllFoldersByQuery = createAsyncThunk(
	'files/fetchAllFolders',
	async ({ page = 1, limit = 5, keyWord = "" }, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.get(`/admin/files/fetch-all-folders?page=${page}&limit=${limit}&keyWord=${keyWord}`);
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
);

// Thunks using axiosInstance
export const fetchAllFilesByQuery = createAsyncThunk(
	'files/fetchAll',
	async ({ page = 1, limit = 5, keyWord = "", filter = "all" }, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.get(
				`/admin/files/fetch-all?page=${page}&limit=${limit}&keyWord=${keyWord}&filter=${filter}`
			);
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
);

export const fetchFileById = createAsyncThunk(
	'files/fetchById',
	async (fileId, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.get(`/admin/files/fetch-file/${fileId}`);
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	})
export const deleteFile = createAsyncThunk(
	'files/delete',
	async (fileId, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.delete(`/admin/files/remove-file/${fileId}`);
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
);
export const deleteFolder = createAsyncThunk(
	'files/folders/removeFolder',
	async (folderId, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.delete(`/admin/files/folders/remove-folder/${folderId}`);
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
);

export const { clearError, clearMessage, clearSelectedFile } = filesSlice.actions;
export default filesSlice.reducer;
